/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Button, Flex, Text } from "@aws-amplify/ui-react";
export default function PrivacyPolicyTermsUseCombined(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="44px"
      direction="column"
      width="1453px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      border="1px SOLID rgba(225,227,231,1)"
      borderRadius="8px"
      padding="59px 79px 59px 79px"
      backgroundColor="rgba(255,255,255,1)"
      {...getOverrideProps(overrides, "PrivacyPolicyTermsUseCombined")}
      {...rest}
    >
      <Flex
        gap="8px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464287")}
      >
        <Text
          fontFamily="Inter"
          fontSize="40px"
          fontWeight="700"
          color="rgba(31,31,31,1)"
          textTransform="capitalize"
          lineHeight="72px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="275px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Privacy Policy"
          {...getOverrideProps(overrides, "Privacy Policy")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="18px"
          fontWeight="400"
          color="rgba(31,31,31,1)"
          lineHeight="27px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="573px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Last Updated on March 16th, 2023"
          {...getOverrideProps(
            overrides,
            "Last Updated on March 16th, 2023560526458"
          )}
        ></Text>
      </Flex>
      <Flex
        gap="44px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464278")}
      >
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464342560526460")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(31,31,31,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Introduction and Scope"
            {...getOverrideProps(overrides, "Introduction and Scope")}
          ></Text>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526462")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='2309225 Alberta Ltd., doing business as "Rhealize" ("Rhealize)", "we", "us", and "our") considers matters relating to the protection of your personal information and your privacy to be extremely important. In order for Rhealize to conduct its business and to manage its relationship with you, we will need to collect, store, use, and disclose some of your personal information. We have developed this privacy policy (the "Privacy Policy") to inform you of the manner in which your personal information will be collected, used and disclosed. This Privacy Policy applies to Rhealize.'
              {...getOverrideProps(
                overrides,
                '2309225 Alberta Ltd., doing business as "Rhealize" ("Rhealize)", "we", "us", and "our") considers matters relating to the protection of your personal information and your privacy to be extremely important. In order for Rhealize to conduct its business and to manage its relationship with you, we will need to collect, store, use, and disclose some of your personal information. We have developed this privacy policy (the "Privacy Policy") to inform you of the manner in which your personal information will be collected, used and disclosed. This Privacy Policy applies to Rhealize.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464343560526464")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="General"
            {...getOverrideProps(overrides, "General")}
          ></Text>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526466")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="We will only collect, use and disclose your personal information as permitted by law. Usually this will require that we obtain your consent for the collection, use and disclosure of your personal information for a particular purpose. However, in certain limited circumstances your consent is not required (for example, where the collection, use or disclosure of the information is reasonable for the purposes of an investigation or legal proceeding, or where a statute or regulation authorizes or requires the collection, use or disclosure of personal information without consent). Rhealize may collect, use and disclose your personal information without your consent or knowledge in those limited circumstances where your consent or knowledge is not required by law."
              {...getOverrideProps(
                overrides,
                "We will only collect, use and disclose your personal information as permitted by law. Usually this will require that we obtain your consent for the collection, use and disclosure of your personal information for a particular purpose. However, in certain limited circumstances your consent is not required (for example, where the collection, use or disclosure of the information is reasonable for the purposes of an investigation or legal proceeding, or where a statute or regulation authorizes or requires the collection, use or disclosure of personal information without consent). Rhealize may collect, use and disclose your personal information without your consent or knowledge in those limited circumstances where your consent or knowledge is not required by law."
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464344560526468")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Personal Information We Collect and How We Collect It"
            {...getOverrideProps(
              overrides,
              "Personal Information We Collect and How We Collect It"
            )}
          ></Text>
          <Flex
            gap="20px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526470")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='We collect personal information primarily for our "Job Seeker" platform which is used to virtually create your electronic resume and connect you with jobs and employers that match your profile and relevant experience. The information we collect includes: first name; last name; home address; email address; employment history, including previous employers, job titles, and descriptions of duties; education, including programs completed; certifications; training/courses completed; professional memberships; history of military service; interests; skills; career goals; information about your ideal work environment, including ideal locations, wages and other preferences; and data from third party psychometric assessments.&#xA;We also use cookies and similar technologies for to collect data analytics on our website for the purposes of research and marketing, in order to determine how users interact with our site. We only collect such information as is reasonably necessary to help us better serve you and our other clients and users and to improve your overall experience interacting on our platform.&#xA;Unless otherwise required or permitted by law or unless otherwise set out in this Privacy Policy: (i) we will only collect your personal information directly from you, and (ii) when we collect your personal information we will inform you of the uses and disclosures that we intend to make of your personal information.'
              {...getOverrideProps(
                overrides,
                'We collect personal information primarily for our "Job Seeker" platform which is used to virtually create your electronic resume and connect you with jobs and employers that match your profile and relevant experience. The information we collect includes: first name; last name; home address; email address; employment history, including previous employers, job titles, and descriptions of duties; education, including programs completed; certifications; training/courses completed; professional memberships; history of military service; interests; skills; career goals; information about your ideal work environment, including ideal locations, wages and other preferences; and data from third party psychometric assessments. We also use cookies and similar technologies for to collect data analytics on our website for the purposes of research and marketing, in order to determine how users interact with our site. We only collect such information as is reasonably necessary to help us better serve you and our other clients and users and to improve your overall experience interacting on our platform. Unless otherwise required or permitted by law or unless otherwise set out in this Privacy Policy: (i) we will only collect your personal information directly from you, and (ii) when we collect your personal information we will inform you of the uses and disclosures that we intend to make of your personal information.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464345560526472")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Use"
            {...getOverrideProps(overrides, "Use")}
          ></Text>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526474")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='We will use personal information you provide only for purposes consistent with the reason you provided it and only for which you have consented to or opted in. Rhealize will use your personal information to create and store an electronic profile of your employment skills, experience and related education, including an electronic resume, for use in our "Job Seeker" platform for matching you with potential employers and our "Candidate Canvas" dashboard, which provides a private summary of your work-life development.&#xA;Rhealize may use data from certain online personal assessment tools (described in the Disclosure section) in conjunction with your personal information to determine the potential employers who are the best matches for your personality and skills.&#xA;We also use personal information to help us develop, deliver, and improve our products, services, and content. We may also use personal information for internal purposes such as auditing, data analysis, and research to improve our products, services, and communications.&#xA;We retain your personal information for as long as is necessary to conduct our business and until you request that your data is removed from our system or for other essential purposes, such as complying with our legal obligations. In the event you cease using the services provided on our website, but do not explicitly request that we remove your personal information from our system, we will retain such information for a period of two (2) years, in accordance with our document retention standards.'
              {...getOverrideProps(
                overrides,
                'We will use personal information you provide only for purposes consistent with the reason you provided it and only for which you have consented to or opted in. Rhealize will use your personal information to create and store an electronic profile of your employment skills, experience and related education, including an electronic resume, for use in our "Job Seeker" platform for matching you with potential employers and our "Candidate Canvas" dashboard, which provides a private summary of your work-life development. Rhealize may use data from certain online personal assessment tools (described in the Disclosure section) in conjunction with your personal information to determine the potential employers who are the best matches for your personality and skills. We also use personal information to help us develop, deliver, and improve our products, services, and content. We may also use personal information for internal purposes such as auditing, data analysis, and research to improve our products, services, and communications. We retain your personal information for as long as is necessary to conduct our business and until you request that your data is removed from our system or for other essential purposes, such as complying with our legal obligations. In the event you cease using the services provided on our website, but do not explicitly request that we remove your personal information from our system, we will retain such information for a period of two (2) years, in accordance with our document retention standards.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464346560526476")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Disclosure"
            {...getOverrideProps(overrides, "Disclosure")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children='Rhealize&apos;s platform matches job seekers with potential employers and as such, we will share your electronic resume, including the personal information you provide to us, with potential employers. Through the Rhealize platform, you are able to access our "Job Seeker" matching software whereby Rhealize will notify you of potential jobs that you may be well matched for. Only once you select "accept" will Rhealize suggest you, as a candidate, to the potential employers at which point your personal information is shared with those potential employers.&#xA;In certain circumstances we may disclose your personal information without obtaining your further consent:&#xA;We may disclose your personal information to comply with securities or other legislation, including the disclosure of your personal information at the request of securities regulators; and&#xA;We may disclose your personal information to comply with legislation relating to money laundering, anti-terrorism and proceeds of crime, including the disclosure of your personal information at the request of investigative authorities.&#xA;Rhealize is committed to our own improvement and to consistently enhancing our users&apos; experience. As part of this commitment, we use several third party online personal assessment products which evaluate our success based on various metrics and statistics. Such personal assessment product providers may share some of your personal information with Rhealize through their engagement with Rhealize. This personal information will only be used in a manner consistent with their purpose and only if you have opted in to providing such information, and have provided it to the third party through their assessment products. Note that the information collected by third parties, including these online personal assessment products, is governed by the privacy practices and policies of those third parties—not this Privacy Policy. We encourage you to learn about the privacy practices and policies of those third parties. The third party online personal assessment products we currently use are:&#xA;Kolbe A™, Kolbe B™ and Kolbe C™ assessments – provided by Kolbe Corp –www.kolbe.com – Copyright © Kolbe Corp. All rights reserved.&#xA;PRINT® assessment – provided by The Paul Hertz Group – https://www.paulhertzgroup.com – Copyright © Paul Hertz Group. All right reserved.&#xA;CliftonStrengths® assessment - provided Gallup, Inc. https://www.gallup.com/cliftonstrengths/en/252137/home.aspx - Copyright © Gallup, Inc. All rights reserved.&#xA;Basic Interest Marker survey – developed by Dr. James Rounds et al at the University of Illinois. Liao, H-Y., Armstrong, P. I., & Rounds, J. (2008). Development and initial validation of public domain basic interest markers [Monograph]. Journal of Vocational Behavior. 73, 159-183. https://doi.org/10.1016/j.jvb.2007.12.002 https://education.illinois.edu/faculty/james-rounds&#xA;Lectical Leadership Decision Making (LDMA) and Lectical Reflective Judgment Assessment (LRJA) – provided by Lectica, Inc. https://lecticalive.org/about/assessments#gsc.tab=0 – Copyright © Lectica, Inc. All rights reserved.&#xA;Qualtrics Surveying platform – used to collect survey responses for the Basic Interest Marker survey. Licensed through a subscription service purchased by Rhealize. https://www.qualtrics.com/&#xA;Ruzuku Learning Management platform – used to provide optional online courses for the benefit of Job Seekers and Employers. Licensed through a subscription service purchased by Rhealize. https://www.ruzuku.com/&#xA;Rhealize also uses other third-party service providers for other purposes, including PayPal and Stripe for payment processing and ActiveDEMAND and Meet Alfred for email campaigns for users who have chosen to be contacted via email.&#xA;In the event that Rhealize transfers or is considering transferring control of its operations to another organization (including through amalgamation), Rhealize may transfer and disclose your personal information to that organization, for the limited purpose of enabling the parties involved in the transfer or proposed transfer to evaluate and, if applicable, carry out the transfer. In those cases, Rhealize will require that the organization receiving the disclosed personal information agrees that it will only use or disclose your personal information as we are similarly entitled to under this Privacy Policy.&#xA;We may engage other service providers to assist us in our activities, including, without limitation, legal counsel, accountants, auditors, investment advisors and information technology service providers. It may be necessary for us to disclose your personal information to these service providers in some circumstances. When we provide personal information to services providers, we require those services providers to protect the information in the same manner as we do. These service providers may not use your personal information for any purpose other than the reason you provided it to us.'
            {...getOverrideProps(
              overrides,
              'Rhealize\'s platform matches job seekers with potential employers and as such, we will share your electronic resume, including the personal information you provide to us, with potential employers. Through the Rhealize platform, you are able to access our "Job Seeker" matching software whereby Rhealize will notify you of potential jobs that you may be well matched for. Only once you select "accept" will Rhealize suggest you, as a candidate, to the potential employers at which point your personal information is shared with those potential employers. In certain circumstances we may disclose your personal information without obtaining your further consent: We may disclose your personal information to comply with securities or other legislation, including the disclosure of your personal information at the request of securities regulators; and We may disclose your personal information to comply with legislation relating to money laundering, anti-terrorism and proceeds of crime, including the disclosure of your personal information at the request of investigative authorities. Rhealize is committed to our own improvement and to consistently enhancing our users\' experience. As part of this commitment, we use several third party online personal assessment products which evaluate our success based on various metrics and statistics. Such personal assessment product providers may share some of your personal information with Rhealize through their engagement with Rhealize. This personal information will only be used in a manner consistent with their purpose and only if you have opted in to providing such information, and have provided it to the third party through their assessment products. Note that the information collected by third parties, including these online personal assessment products, is governed by the privacy practices and policies of those third parties\u2014not this Privacy Policy. We encourage you to learn about the privacy practices and policies of those third parties. The third party online personal assessment products we currently use are: Kolbe A\u2122, Kolbe B\u2122 and Kolbe C\u2122 assessments \u2013 provided by Kolbe Corp \u2013www.kolbe.com \u2013 Copyright \u00A9 Kolbe Corp. All rights reserved. PRINT\u00AE assessment \u2013 provided by The Paul Hertz Group \u2013 https://www.paulhertzgroup.com \u2013 Copyright \u00A9 Paul Hertz Group. All right reserved. CliftonStrengths\u00AE assessment - provided Gallup, Inc. https://www.gallup.com/cliftonstrengths/en/252137/home.aspx - Copyright \u00A9 Gallup, Inc. All rights reserved. Basic Interest Marker survey \u2013 developed by Dr. James Rounds et al at the University of Illinois. Liao, H-Y., Armstrong, P. I., & Rounds, J. (2008). Development and initial validation of public domain basic interest markers [Monograph]. Journal of Vocational Behavior. 73, 159-183. https://doi.org/10.1016/j.jvb.2007.12.002 https://education.illinois.edu/faculty/james-rounds Lectical Leadership Decision Making (LDMA) and Lectical Reflective Judgment Assessment (LRJA) \u2013 provided by Lectica, Inc. https://lecticalive.org/about/assessments#gsc.tab=0 \u2013 Copyright \u00A9 Lectica, Inc. All rights reserved. Qualtrics Surveying platform \u2013 used to collect survey responses for the Basic Interest Marker survey. Licensed through a subscription service purchased by Rhealize. https://www.qualtrics.com/ Ruzuku Learning Management platform \u2013 used to provide optional online courses for the benefit of Job Seekers and Employers. Licensed through a subscription service purchased by Rhealize. https://www.ruzuku.com/ Rhealize also uses other third-party service providers for other purposes, including PayPal and Stripe for payment processing and ActiveDEMAND and Meet Alfred for email campaigns for users who have chosen to be contacted via email. In the event that Rhealize transfers or is considering transferring control of its operations to another organization (including through amalgamation), Rhealize may transfer and disclose your personal information to that organization, for the limited purpose of enabling the parties involved in the transfer or proposed transfer to evaluate and, if applicable, carry out the transfer. In those cases, Rhealize will require that the organization receiving the disclosed personal information agrees that it will only use or disclose your personal information as we are similarly entitled to under this Privacy Policy. We may engage other service providers to assist us in our activities, including, without limitation, legal counsel, accountants, auditors, investment advisors and information technology service providers. It may be necessary for us to disclose your personal information to these service providers in some circumstances. When we provide personal information to services providers, we require those services providers to protect the information in the same manner as we do. These service providers may not use your personal information for any purpose other than the reason you provided it to us.'
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464347560526479")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Choices"
            {...getOverrideProps(overrides, "Choices")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="You have certain choices relating to your personal information we collect and use. You must opt-in to having your information shared with potential employers as well as to participating in any academic research studies conducted by Rhealize.&#xA;At any time, you may request that any or all of your personal data is removed from our systems and Rhealize will ensure that it is deleted from our records other than copies which are retained in our computers archival and backup servers, which will be retained in accordance with standard document retention policies.&#xA;You may also request that we provide you with access to the personal information that we hold about you. You may ask us to correct any errors or delete any of the information we have about you. We note, however, that your ability to exercise these choices is not absolute. In some circumstances (for example, if the information is protected by legal privilege or if the information was collected for an investigation or legal proceeding), we may be permitted or obliged to deny such requests. In addition, to protect your privacy and the privacy of others, we may have to verify that you are who you say you are before we can give you access to, or change, information about you."
            {...getOverrideProps(
              overrides,
              "You have certain choices relating to your personal information we collect and use. You must opt-in to having your information shared with potential employers as well as to participating in any academic research studies conducted by Rhealize. At any time, you may request that any or all of your personal data is removed from our systems and Rhealize will ensure that it is deleted from our records other than copies which are retained in our computers archival and backup servers, which will be retained in accordance with standard document retention policies. You may also request that we provide you with access to the personal information that we hold about you. You may ask us to correct any errors or delete any of the information we have about you. We note, however, that your ability to exercise these choices is not absolute. In some circumstances (for example, if the information is protected by legal privilege or if the information was collected for an investigation or legal proceeding), we may be permitted or obliged to deny such requests. In addition, to protect your privacy and the privacy of others, we may have to verify that you are who you say you are before we can give you access to, or change, information about you."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464348560526482")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(31,31,31,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="How to Contact Us"
            {...getOverrideProps(overrides, "How to Contact Us")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="You may contact us, to ask questions or exercise choices relating to this Privacy Policy, in the following ways:&#xA;&#xA;Privacy Officer: Lisa Zeppetzauer, President and Co-Founder&#xA;Phone: 780-504-4136&#xA;Email: lzepp@Rhealize.com"
            {...getOverrideProps(
              overrides,
              "You may contact us, to ask questions or exercise choices relating to this Privacy Policy, in the following ways: Privacy Officer: Lisa Zeppetzauer, President and Co-Founder Phone: 780-504-4136 Email: lzepp@Rhealize.com"
            )}
          ></Text>
        </Flex>
      </Flex>
      <Flex
        gap="8px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464288")}
      >
        <Text
          fontFamily="Inter"
          fontSize="40px"
          fontWeight="700"
          color="rgba(31,31,31,1)"
          textTransform="capitalize"
          lineHeight="72px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="264px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Terms of Use"
          {...getOverrideProps(overrides, "Terms of Use")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="18px"
          fontWeight="400"
          color="rgba(31,31,31,1)"
          lineHeight="27px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="573px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Last Updated on March 16th, 2023"
          {...getOverrideProps(
            overrides,
            "Last Updated on March 16th, 2023560526487"
          )}
        ></Text>
      </Flex>
      <Flex
        gap="44px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464289")}
      >
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464342560526519")}
        >
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526520")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='The following terms and conditions (collectively, "Terms of Use") govern your access to and use of the [rhealize.com] website and all related mobile apps, desktop apps, and application software interfaces (the "Platform") operated by 2309225 Alberta Ltd. ("Company", "we" or "us"), including any content, features and services offered on or through the Platform, whether as a guest or a registered user.&#xA;Please read these Terms of Use carefully before you start to use the Platform. By using the Platform or by clicking to accept or agree to the Terms of Use when this option is made available to you, you accept and agree to be bound and abide by these Terms of Use and our privacy policy (the "Privacy Policy"), found at [PRIVACY POLICY URL] and incorporated into these Terms of Use by reference. If you do not agree to these Terms of Use or the Privacy Policy, you may not access or use the Platform.'
              {...getOverrideProps(
                overrides,
                'The following terms and conditions (collectively, "Terms of Use") govern your access to and use of the [rhealize.com] website and all related mobile apps, desktop apps, and application software interfaces (the "Platform") operated by 2309225 Alberta Ltd. ("Company", "we" or "us"), including any content, features and services offered on or through the Platform, whether as a guest or a registered user. Please read these Terms of Use carefully before you start to use the Platform. By using the Platform or by clicking to accept or agree to the Terms of Use when this option is made available to you, you accept and agree to be bound and abide by these Terms of Use and our privacy policy (the "Privacy Policy"), found at [PRIVACY POLICY URL] and incorporated into these Terms of Use by reference. If you do not agree to these Terms of Use or the Privacy Policy, you may not access or use the Platform.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464343560526522")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="1. Changes to the Terms of Use"
            {...getOverrideProps(overrides, "1. Changes to the Terms of Use")}
          ></Text>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526524")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="We may change and update these Terms of Use from time to time in our sole discretion. All changes are effective immediately when we post them, and apply after that to all access to and use of the Platform and any related content or services. If you continue to use the Platform or our services after we post revised Terms of Use, then you accept and agree to the changes. Check this page often so you are aware of any changes."
              {...getOverrideProps(
                overrides,
                "We may change and update these Terms of Use from time to time in our sole discretion. All changes are effective immediately when we post them, and apply after that to all access to and use of the Platform and any related content or services. If you continue to use the Platform or our services after we post revised Terms of Use, then you accept and agree to the changes. Check this page often so you are aware of any changes."
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464344560526526")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="2. Accessing the Platform; Account Registration and Security"
            {...getOverrideProps(
              overrides,
              "2. Accessing the Platform; Account Registration and Security"
            )}
          ></Text>
          <Flex
            gap="20px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526528")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='We reserve the right to withdraw or change the Platform, and any service or content we provide on the Platform, in our sole discretion without notice. We will not be liable if, for any reason, all or any part of the Platform is unavailable at any time or for any period. From time to time, we may restrict access to some parts or all of the Platform.&#xA;To access and use certain features of the Platform, you must register an account ("Account"). It is a condition of your use of the Platform that all the information you provide on the Platform is correct, current and complete. You agree that all information you provide to register with or use the Platform, including through the use of any interactive features on the Platform, is governed by the Privacy Policy, and you consent to everything we do with your information, as long as it is consistent with our Privacy Policy.&#xA;Your Account is personal to you and agree not to provide any other person with access to the Platform or portions of it using your user name, password or other security information. You agree not to give or tell your username or password to any other person. You agree to notify us immediately of any unauthorized access to or use of your user name or password or any other breach of security.&#xA;We have the right to disable any user name, password or other identifier at any time in our sole discretion for any reason, including if, in our opinion, you have violated any part of these Terms of Use.'
              {...getOverrideProps(
                overrides,
                'We reserve the right to withdraw or change the Platform, and any service or content we provide on the Platform, in our sole discretion without notice. We will not be liable if, for any reason, all or any part of the Platform is unavailable at any time or for any period. From time to time, we may restrict access to some parts or all of the Platform. To access and use certain features of the Platform, you must register an account ("Account"). It is a condition of your use of the Platform that all the information you provide on the Platform is correct, current and complete. You agree that all information you provide to register with or use the Platform, including through the use of any interactive features on the Platform, is governed by the Privacy Policy, and you consent to everything we do with your information, as long as it is consistent with our Privacy Policy. Your Account is personal to you and agree not to provide any other person with access to the Platform or portions of it using your user name, password or other security information. You agree not to give or tell your username or password to any other person. You agree to notify us immediately of any unauthorized access to or use of your user name or password or any other breach of security. We have the right to disable any user name, password or other identifier at any time in our sole discretion for any reason, including if, in our opinion, you have violated any part of these Terms of Use.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464345560526530")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="3. Copyrights, Trademarks, and other Intellectual Property Rights"
            {...getOverrideProps(
              overrides,
              "3. Copyrights, Trademarks, and other Intellectual Property Rights"
            )}
          ></Text>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464343560526532")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(0,0,0,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children='The Platform and its entire contents, features and functionality (including all information, software, text, displays, images, video and audio, and the design, selection and arrangement of each), are owned by the Company, its licensors or other providers of such material and are protected by Canadian and international copyright, trademark, trade secret and other intellectual property or proprietary rights laws.&#xA;These Terms of Use permit you to use the Platform for your own use only. You may not, without the Company&apos;s prior written consent, reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store or transmit any of the material on our Platform.&#xA;"Rhealize", "Friction Free" and all related names, logos, product and service names, designs and slogans are trademarks of the Company or its affiliates or licensors. You may not use such marks without the prior written consent of the Company. All other names, logos, product and service names, designs and slogans on the Platform are the trademarks of their respective owners.&#xA;No right, title or interest in the Platform or any content on the Platform is transferred to you, and all rights not expressly granted are reserved by the Company. Any use of the Platform not expressly permitted by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark and other laws.'
              {...getOverrideProps(
                overrides,
                'The Platform and its entire contents, features and functionality (including all information, software, text, displays, images, video and audio, and the design, selection and arrangement of each), are owned by the Company, its licensors or other providers of such material and are protected by Canadian and international copyright, trademark, trade secret and other intellectual property or proprietary rights laws. These Terms of Use permit you to use the Platform for your own use only. You may not, without the Company\'s prior written consent, reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store or transmit any of the material on our Platform. "Rhealize", "Friction Free" and all related names, logos, product and service names, designs and slogans are trademarks of the Company or its affiliates or licensors. You may not use such marks without the prior written consent of the Company. All other names, logos, product and service names, designs and slogans on the Platform are the trademarks of their respective owners. No right, title or interest in the Platform or any content on the Platform is transferred to you, and all rights not expressly granted are reserved by the Company. Any use of the Platform not expressly permitted by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark and other laws.'
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464346560526534")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="4. Prohibited Uses"
            {...getOverrideProps(overrides, "4. Prohibited Uses")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="500"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="You may use the Platform only for lawful purposes and in accordance with these Terms of Use.&#xA;(a) You agree not to use the Platform:&#xA;(i) in any way that violates any applicable federal, provincial, state, local or international law or regulation;&#xA;(ii) for the purpose of exploiting, harming or attempting to exploit or harm minors in any way by exposing them to inappropriate content, asking for personally identifiable information or otherwise;&#xA;(iii) to reverse engineer or access the Platform in order to build a competitive product or service, or to build a product or service using similar features, functions or look and feel; or&#xA;(iv) to do anything that restricts or inhibits anyone's use or enjoyment of the Platform, or which, as determined by us, may harm the Company or users of the Platform or expose them to liability.&#xA;(b) You agree not to:&#xA;(i) use any process to monitor or copy any of the material on the Platform or for any other unauthorized purpose without our prior written consent;&#xA;(ii) use any device, software or routine that interferes with the proper working of the Platform;&#xA;(iii) introduce any viruses, malware or other material which is malicious or technologically harmful;&#xA;(iv) attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of the Platform, any server on which any portion of the Platform is stored, or any server, computer or database connected to the Platform; or&#xA;(v) otherwise attempt to interfere with the proper working of the Platform."
            {...getOverrideProps(
              overrides,
              "You may use the Platform only for lawful purposes and in accordance with these Terms of Use. (a) You agree not to use the Platform: (i) in any way that violates any applicable federal, provincial, state, local or international law or regulation; (ii) for the purpose of exploiting, harming or attempting to exploit or harm minors in any way by exposing them to inappropriate content, asking for personally identifiable information or otherwise; (iii) to reverse engineer or access the Platform in order to build a competitive product or service, or to build a product or service using similar features, functions or look and feel; or (iv) to do anything that restricts or inhibits anyone's use or enjoyment of the Platform, or which, as determined by us, may harm the Company or users of the Platform or expose them to liability. (b) You agree not to: (i) use any process to monitor or copy any of the material on the Platform or for any other unauthorized purpose without our prior written consent; (ii) use any device, software or routine that interferes with the proper working of the Platform; (iii) introduce any viruses, malware or other material which is malicious or technologically harmful; (iv) attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of the Platform, any server on which any portion of the Platform is stored, or any server, computer or database connected to the Platform; or (v) otherwise attempt to interfere with the proper working of the Platform."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464347560526537")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="5. Beta Services"
            {...getOverrideProps(overrides, "5. Beta Services")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="500"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children='You may be offered an opportunity to take part in early access programs to use so-called "beta" or in-development versions of our services ("Beta Services"). You acknowledge and agree that Beta Services may not comply, in some respects, with our documentation for them, or they may contain errors, defects or bugs. We do not make any representations and warranties, and we disclaim all liabilities, respecting Beta Services. Beta Services may be discontinued at any time, for no reason and without prior notice, and nothing in these Terms of Use may be construed as requiring us to include Beta Services as part of the Platform.'
            {...getOverrideProps(
              overrides,
              'You may be offered an opportunity to take part in early access programs to use so-called "beta" or in-development versions of our services ("Beta Services"). You acknowledge and agree that Beta Services may not comply, in some respects, with our documentation for them, or they may contain errors, defects or bugs. We do not make any representations and warranties, and we disclaim all liabilities, respecting Beta Services. Beta Services may be discontinued at any time, for no reason and without prior notice, and nothing in these Terms of Use may be construed as requiring us to include Beta Services as part of the Platform.'
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464348560526540")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="36px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="6. Service Fees and Payment Methods"
            {...getOverrideProps(
              overrides,
              "6. Service Fees and Payment Methods"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children='The Company may charge fees to you for the use of various features of the Platform or services provided through or in association with the Platform ("Service Fees"). [The current Service Fees are listed on the Platform.  We reserve the right to change these fees from time to time in our sole discretion. We will provide advance notice on the Platform of any Service Fee changes before they become effective. You agree to pay all Service Fees and other amounts, including all applicable taxes, the Company applies to your Account.&#xA;When you add a payment method to your Account, you will be asked to provide customary billing information, either to the Company or to its third-party payment processor. You must provide and maintain accurate, current, and complete information for at least one valid payment method, at all times.'
            {...getOverrideProps(
              overrides,
              'The Company may charge fees to you for the use of various features of the Platform or services provided through or in association with the Platform ("Service Fees"). [The current Service Fees are listed on the Platform. We reserve the right to change these fees from time to time in our sole discretion. We will provide advance notice on the Platform of any Service Fee changes before they become effective. You agree to pay all Service Fees and other amounts, including all applicable taxes, the Company applies to your Account. When you add a payment method to your Account, you will be asked to provide customary billing information, either to the Company or to its third-party payment processor. You must provide and maintain accurate, current, and complete information for at least one valid payment method, at all times.'
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464349")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="7. Monitoring and Enforcement; Termination"
            {...getOverrideProps(
              overrides,
              "7. Monitoring and Enforcement; Termination"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="We have the right to:&#xA;· take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Platform.&#xA;· terminate or suspend your access to all or part of the Platform for any reason, including any violation of these Terms of Use.&#xA;We have the right to fully cooperate with any law enforcement authorities or court order requesting or directing us to disclose the identity or other information of anyone posting any materials on or through the Platform. You waive and hold the Company harmless from any claims resulting from any action taken by the Company during or as a result of its investigations and from any actions taken as a consequence of investigations by either the Company or law enforcement authorities."
            {...getOverrideProps(
              overrides,
              "We have the right to: \u00B7 take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Platform. \u00B7 terminate or suspend your access to all or part of the Platform for any reason, including any violation of these Terms of Use. We have the right to fully cooperate with any law enforcement authorities or court order requesting or directing us to disclose the identity or other information of anyone posting any materials on or through the Platform. You waive and hold the Company harmless from any claims resulting from any action taken by the Company during or as a result of its investigations and from any actions taken as a consequence of investigations by either the Company or law enforcement authorities."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464350")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="8. Changes to the Platform"
            {...getOverrideProps(overrides, "8. Changes to the Platform")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="We may update the content on the Platform from time to time, but its content is not necessarily complete or up-to-date. Any of the material on the Platform may be out of date at any given time, and we are under no obligation to keep material on the Platform up-to-date."
            {...getOverrideProps(
              overrides,
              "We may update the content on the Platform from time to time, but its content is not necessarily complete or up-to-date. Any of the material on the Platform may be out of date at any given time, and we are under no obligation to keep material on the Platform up-to-date."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464351")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="9. Links from the Platform"
            {...getOverrideProps(overrides, "9. Links from the Platform")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="If the Platform contains links to other sites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. We have no control over the contents of those sites or resources, and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third party websites linked to this Platform, you do so entirely at your own risk and subject to the terms and conditions of use for such websites."
            {...getOverrideProps(
              overrides,
              "If the Platform contains links to other sites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. We have no control over the contents of those sites or resources, and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third party websites linked to this Platform, you do so entirely at your own risk and subject to the terms and conditions of use for such websites."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464352")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="10. Disclaimer of Warranties"
            {...getOverrideProps(overrides, "10. Disclaimer of Warranties")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children='You understand that we cannot and do not guarantee or warrant that files available for downloading from the internet or the Platform will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data.&#xA;Your use of the Platform, its content and any goods or services obtained through the Platform is at your own risk. The Platform, its content and any goods or services obtained through the Platform are provided on an "as is" and "as available" basis, without any warranties of any kind, either express or implied. Neither the Company nor any person associated with the Company makes any warranty or representation with respect to the completeness, security, reliability, quality, accuracy or availability of the Platform. Without limiting the foregoing, neither the Company nor anyone associated with the Company represents or warrants that the Platform, its content or any goods or services obtained through the Platform will be accurate, reliable, error-free or uninterrupted, that defects will be corrected, that our Platform or the servers that make it available are free of viruses or other harmful components or that the Platform or any goods or services obtained through the Platform will otherwise meet your needs or expectations.&#xA;To the fullest extent allowed under applicable law, the Company hereby disclaims all warranties of any kind, whether express or implied, statutory or otherwise, including but not limited to any warranties of merchantability, non-infringement and fitness for particular purpose.'
            {...getOverrideProps(
              overrides,
              'You understand that we cannot and do not guarantee or warrant that files available for downloading from the internet or the Platform will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data. Your use of the Platform, its content and any goods or services obtained through the Platform is at your own risk. The Platform, its content and any goods or services obtained through the Platform are provided on an "as is" and "as available" basis, without any warranties of any kind, either express or implied. Neither the Company nor any person associated with the Company makes any warranty or representation with respect to the completeness, security, reliability, quality, accuracy or availability of the Platform. Without limiting the foregoing, neither the Company nor anyone associated with the Company represents or warrants that the Platform, its content or any goods or services obtained through the Platform will be accurate, reliable, error-free or uninterrupted, that defects will be corrected, that our Platform or the servers that make it available are free of viruses or other harmful components or that the Platform or any goods or services obtained through the Platform will otherwise meet your needs or expectations. To the fullest extent allowed under applicable law, the Company hereby disclaims all warranties of any kind, whether express or implied, statutory or otherwise, including but not limited to any warranties of merchantability, non-infringement and fitness for particular purpose.'
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464353")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="11. Limitation on Liability"
            {...getOverrideProps(overrides, "11. Limitation on Liability")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="600"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="In no event will the Company, its affiliates or their licensors, service providers, employees, agents, officers or directors be liable for damages of any kind, under any legal theory, arising out of or in connection with your use of, or inability to use, the Platform, any websites linked to it, any content on the Platform or such other websites or any goods or services obtained through the Platform or such other websites, including any direct, indirect, special, incidental, consequential or punitive damages, including but not limited to, personal injury, pain and suffering, emotional distress, loss of revenue, loss of profits, loss of business or anticipated savings, loss of use, loss of goodwill, loss of data, and whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable.&#xA;The foregoing does not affect any liability which cannot be excluded or limited under applicable law."
            {...getOverrideProps(
              overrides,
              "In no event will the Company, its affiliates or their licensors, service providers, employees, agents, officers or directors be liable for damages of any kind, under any legal theory, arising out of or in connection with your use of, or inability to use, the Platform, any websites linked to it, any content on the Platform or such other websites or any goods or services obtained through the Platform or such other websites, including any direct, indirect, special, incidental, consequential or punitive damages, including but not limited to, personal injury, pain and suffering, emotional distress, loss of revenue, loss of profits, loss of business or anticipated savings, loss of use, loss of goodwill, loss of data, and whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable. The foregoing does not affect any liability which cannot be excluded or limited under applicable law."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464354")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="12. Indemnification"
            {...getOverrideProps(overrides, "12. Indemnification")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="You agree to defend, indemnify and hold harmless the Company, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable legal fees) arising out of or relating to your violation of these Terms of Use or your use of the Platform, including, your User Contributions, any use of the Platform's content, services and products other than as expressly authorized in these Terms of Use."
            {...getOverrideProps(
              overrides,
              "You agree to defend, indemnify and hold harmless the Company, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable legal fees) arising out of or relating to your violation of these Terms of Use or your use of the Platform, including, your User Contributions, any use of the Platform's content, services and products other than as expressly authorized in these Terms of Use."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464355")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="13. Governing Law and Jurisdiction"
            {...getOverrideProps(
              overrides,
              "13. Governing Law and Jurisdiction"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="All matters relating to the Platform and these Terms of Use and any dispute or claim arising therefrom or related thereto (in each case, including non-contractual disputes or claims), will be governed by and construed in accordance with the laws of the Province of Alberta and the federal laws of Canada without giving effect to any choice or conflict of law provision or rule.&#xA;Any legal suit, action or proceeding arising out of, or related to, these Terms of Use or the Platform must be instituted exclusively in the federal courts of Canada or the courts of the Province of Alberta, in each case located in the City of Calgary. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts."
            {...getOverrideProps(
              overrides,
              "All matters relating to the Platform and these Terms of Use and any dispute or claim arising therefrom or related thereto (in each case, including non-contractual disputes or claims), will be governed by and construed in accordance with the laws of the Province of Alberta and the federal laws of Canada without giving effect to any choice or conflict of law provision or rule. Any legal suit, action or proceeding arising out of, or related to, these Terms of Use or the Platform must be instituted exclusively in the federal courts of Canada or the courts of the Province of Alberta, in each case located in the City of Calgary. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464356")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="14. Waiver and Severability"
            {...getOverrideProps(overrides, "14. Waiver and Severability")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="No waiver of by the Company of any term or condition in these Terms of Use will be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the Company to assert a right or provision under these Terms of Use will not be a waiver of that right or provision.&#xA;If any provision of these Terms of Use is held by a court or other tribunal of competent jurisdiction to be invalid, illegal or unenforceable for any reason, that provision will be eliminated or limited to the minimum extent such that the remaining provisions of the Terms of Use will continue in full force and effect."
            {...getOverrideProps(
              overrides,
              "No waiver of by the Company of any term or condition in these Terms of Use will be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the Company to assert a right or provision under these Terms of Use will not be a waiver of that right or provision. If any provision of these Terms of Use is held by a court or other tribunal of competent jurisdiction to be invalid, illegal or unenforceable for any reason, that provision will be eliminated or limited to the minimum extent such that the remaining provisions of the Terms of Use will continue in full force and effect."
            )}
          ></Text>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464357")}
        >
          <Text
            fontFamily="Inter"
            fontSize="22px"
            fontWeight="700"
            color="rgba(0,0,0,1)"
            textTransform="capitalize"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="15. Interpretation"
            {...getOverrideProps(overrides, "15. Interpretation")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="27px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children='In these Terms of Use: (a) the words "include," "includes" and "including" are deemed to be followed by the words "without limitation"; (b) references to an agreement or other document include any amendments to that agreement or document; and (c) references to a law include any changes to that law or any replacement to that law.'
            {...getOverrideProps(
              overrides,
              'In these Terms of Use: (a) the words "include," "includes" and "including" are deemed to be followed by the words "without limitation"; (b) references to an agreement or other document include any amendments to that agreement or document; and (c) references to a law include any changes to that law or any replacement to that law.'
            )}
          ></Text>
        </Flex>
      </Flex>
      <Button
        width="unset"
        height="unset"
        shrink="0"
        alignSelf="stretch"
        size="default"
        isDisabled={false}
        variation="primary"
        children="I agree"
        {...getOverrideProps(overrides, "Button")}
      ></Button>
    </Flex>
  );
}
